import React, { Component } from 'react'
import { useFela } from 'react-fela'
import theme from '@modul-connect/shared/theme'
import Page from '@modul-connect/shared/components/atoms/page'
import Input from '@modul-connect/shared/components/atoms/input'
import View from '@modul-connect/shared/components/atoms/view'
import { Span } from '@modul-connect/shared/components/atoms/text'
import { Icon } from '../../atoms/icon'

const TextField = ({
  extend,
  onChange,
  disabled,
  placeholder,
  onBlur,
  focus,
  type,
  name,
  error,
  errorText,
  value,
  icon,
  button,
  inlineText,
  step,
  buttonExtend
}) => {

  return (
    <View extend={error && styles.error}>
      <Span extend={ [styles.span ] }>{ name } { errorText && errorText }</Span>
      <View extend={styles.inputWrap}>
        <Input
          disabled={ disabled }
          extend={ [styles.input, extend && extend ] }
          type={ type }
          step={step}
          innerRef={ focus ? input => input && input.focus() : null }
          placeholder={ placeholder }
          onBlur={event => { if(onBlur) { onBlur(event)}}}
          onChange={event => { if(onChange) { onChange(event)}}}
          value={ value }
        />
        {icon && (
          <View extend={styles.rightIcon}> 
            {icon ? <Icon icon={icon}/> : null}
          </View>
        )}
        {button && (
          <View extend={{ ...styles.inlineButton, ...buttonExtend }}> 
            {button}
          </View>
        )}
        {inlineText && (
          <View extend={styles.inlineValue}>
            {inlineText}
          </View>
        )}
      </View>
    </View>
  )
}

const styles = {
  inputWrap: {
    position: 'relative',
    width: '100%',

  },
  input: {
    border: `1px solid ${ theme.colors.lightGrey }`,
    marginBottom: 15, 
  },
  span: {
    fontSize: 12,
    marginLeft: 3,
    color: theme.colors.darkGrey
  },
  error: {
    '& span': {
      color: theme.colors.error,
    },
    '& input': {
      border: `1px solid ${ theme.colors.error }`
    }
  },
  rightIcon: {
    position: 'absolute',
    top: '50%',
    right: 10,
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    lineHeight: 0,

  },
  inlineButton: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: 16,
    lineHeight: '19px',
    color: theme.colors.blue,         
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  inlineValue: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: 16,
    lineHeight: '19px',
    color: '#646464',         
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
}

export default TextField